import React from 'react';
import {
  useSnackbar,
  Snackbar,
  Snack,
  SnackCloseButton,
  InputSnackProps,
  RegularButton,
} from 'fronton-react';
import { MobileSnackbarClassName } from './style';

type SnackActionType = () => void;

const isAction = (action: unknown): action is SnackActionType =>
  Boolean(action) && typeof action === 'function';

interface SnackProps extends InputSnackProps {
  action?: SnackActionType;
  button?: string;
  buttonClassName?: string;
  showCloseButton?: boolean;
  autoHideTimer?: number;
}

type RenderSnacksParams = {
  snacks: SnackProps[];
  removeSnack: (id: string) => void;
};

const renderSnacks = ({ snacks, removeSnack }: RenderSnacksParams) =>
  snacks.map(
    ({
      id,
      title,
      content,
      icon,
      variant,
      button,
      autoHideTimer,
      wide,
      action,
      buttonClassName,
      testId,
      showCloseButton,
    }) => (
      <Snack
        data-qa={testId}
        key={id}
        id={id}
        header={title}
        paragraph={content}
        icon={icon}
        variant={variant}
        wideButton={wide}
        autoHideTimer={autoHideTimer}
        closeButton={showCloseButton ? <SnackCloseButton onClick={() => removeSnack(id)} /> : undefined}
      >
        {button && (
          <RegularButton
            size="s"
            invert
            className={buttonClassName}
            onClick={() => {
              if (isAction(action)) {
                action();
              }
              removeSnack(id);
            }}
          >
            {button}
          </RegularButton>
        )}
      </Snack>
    ),
  );

export const HeaderSnackbar = () => {
  const { state, removeSnack } = useSnackbar();
  const snacks = state as SnackProps[];

  return <Snackbar className={MobileSnackbarClassName}>{renderSnacks({ snacks, removeSnack })}</Snackbar>;
};
